import commonText from './commonText';

const digitalModes = {
  digital: {
    displayLabel: 'Digital',
    initialSelected: false,
    initialImpactFactor: 0.1,
    initialDiscount: 0.75,
    costText: '(overall CPM across platforms, excluding Social/Mobile)',
    costTooltip: '(overall CPM across platforms, excluding Social/Mobile)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'desktop',
  },
  mobile: {
    displayLabel: 'Mobile',
    initialSelected: false,
    initialImpactFactor: 0.25,
    initialDiscount: 0.75,
    costText: '(CPM for digital ads on mobile platforms)',
    costTooltip: '(CPM for digital ads on mobile platforms)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'mobile',
  },
  fb: {
    displayLabel: 'Facebook',
    initialSelected: false,
    initialImpactFactor: 0.2,
    initialDiscount: 0.5,
    costText: '(CPM for ads on Facebook)',
    costTooltip: '(CPM for ads on Facebook)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'facebook',
  },
};

export default digitalModes;
